export enum ContentPreferences {
    conceptTests = 'conceptTests',
    video = 'video',
    chapterTests = 'chapterTests',
    studyNotes = 'studyNotes',
    scheduledTests = 'scheduledTests',
    sampleTests='sampleTests',
    mainTests='mainTests',
    formulas='formulas',
}